'use strict';

import {brWp} from './brwp.js';

export class br
{
	wp = {};
	total = {
		initial: 0,
		proposed: 0,
		reduction: 0
	};
	
	constructor(data){
		
		this.setupData(data);
		this.countTotal();
	}
	
	setupData(data){
		if(typeof(data.wp) !== 'undefined'){
			for(let id in data.wp){
				let wp = new brWp(data.wp[id]);
				this.wp[wp.id] = wp;
			}
		}
	}
	
	countTotal(){
		let total = {
			initial: 0,
			proposed: 0,
			reduction: 0
		};
		for(let id in this.wp){
			this.wp[id].countTotal();
			total.initial += this.wp[id].total.initial;
			total.proposed += this.wp[id].total.proposed;
			total.reduction += this.wp[id].total.reduction;
		}
		this.total = total;
	}
	
	getInitial(){
		this.countTotal();
		return this.total.initial;
	}
	
	getProposed(){
		this.countTotal();
		return this.total.proposed;
	}
	
	getReduction(){
		this.countTotal();
		return this.total.reduction;
	}
	
	getWpList(){
		return Object.values(this.wp);
	}
}